import FieldRenderer from "../global/forms/FieldRenderer";
import dataConstants from "../../constants/dataConstants";
import OnlineOrderFormProps from "../../services/models/formModels/OnlineOrderForm.model";

function AdditionalInformationFields({
  touched,
  errors,
  handleChange,
  handleBlur,
  values,
  getFieldMeta,
  setFieldValue,
}: OnlineOrderFormProps): JSX.Element {
  return (
    <FieldRenderer
      fields={dataConstants.additionalInformationFieldsPickup.map(
        (field, index) => ({
          key: `${index}${field.labelInfo?.inputId}`,
          ...field,
          getFieldMeta,
          setFieldValue,
          values,
          errors: errors,
          touched: touched,
          onChange: handleChange,
          value: values?.[!!field?.name ? field.name : ""],
          onBlur: handleBlur,
          name: field.name,
          roundedInput: true,
        })
      )}
    />
  );
}

export default AdditionalInformationFields;
